// src/modules/auth/ui/CodeInput.tsx

/** @jsx createElement */
import { createElement } from "../../../utils/jsx.ts";

import { CODE_LENGTH, SINGLE_DIGIT_REGEX } from "../constants.ts";

interface Params {
  name: string;
}

export const CodeInput = ({ name }: Params) => {
  const codeInput = (
    <label>
      <p>Kod</p>
      <div class="code-input">
        <input type="number" name={name + "-1"} required min="0" max="9" />
        <input type="number" name={name + "-2"} required min="0" max="9" />
        <input type="number" name={name + "-3"} required min="0" max="9" />
        <div class="divider"></div>
        <input type="number" name={name + "-4"} required min="0" max="9" />
        <input type="number" name={name + "-5"} required min="0" max="9" />
        <input type="number" name={name + "-6"} required min="0" max="9" />
      </div>
    </label>
  );

  const inputs: NodeListOf<HTMLInputElement> = codeInput.querySelectorAll("input");
  inputs.forEach((input, index) => {
    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace") {
        e.preventDefault();
        input.value = "";
        inputs[index - 1]?.focus();
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        inputs[index - 1]?.focus();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        inputs[index + 1]?.focus();
      }
    });

    input.addEventListener("input", () => {
      if (input.value.length > 1) {
        input.value = input.value.slice(1, 2);
      }
      if (!/^\d$/.test(input.value)) {
        input.value = "";
        return;
      }
      if (index < CODE_LENGTH - 1) {
        inputs[index + 1]?.focus();
      }
    });

    input.addEventListener("paste", (e) => {
      e.preventDefault();
      const pastedData = e.clipboardData?.getData("text");
      if (!pastedData) return;
      const numbers = pastedData.trim().replace("-", "").slice(0, CODE_LENGTH).split("");

      numbers.forEach((value: string, index: number) => {
        if (!SINGLE_DIGIT_REGEX.test(value)) return;
        inputs[index].value = value;
      });

      if (numbers.length <= CODE_LENGTH) {
        inputs[numbers.length - 1].focus();
      }
    });
  });

  return codeInput;
};
